import { useTranslation } from 'react-i18next'
import { deleteLabel } from '../../../lib/deleteLabel'
import { deleteLabelKey } from '../hooks/useActionListDelete'
import type { ActionListItem } from '../types'
import ActionFollowButton from './ActionFollowButton'
import '../actions.css'
import '../../minutes/minutes.css'

interface Props {
  row: ActionListItem
  /** Silme geri çağrısı — `useActionListDelete`; `undefined` → çöp kutusu hiç çizilmez. */
  onDelete?: (row: ActionListItem) => void
  /** Yıldız bu listede açık mı — `useListFollowEnabled`. */
  followEnabled: boolean
}

/**
 * Görev listesi satırının eylemleri — **yıldız** (120) + **Sil** (2026-09-17). Tablo hücresi ve dar ekran
 * kartı aynı bileşeni çizer; iki yüzeyin kuralları ayrışmasın.
 *
 * - Yıldız yalnız **ana görev** satırında (spec FR-002): Takip Ettiklerim alt görevi listelemez, sunucu da
 *   alt görevde takibi reddeder.
 * - Sil yalnız `row.deletable` iken (yetki `RECORD_DELETE`; kurallar `useActionListDelete`'te).
 *
 * Yıldız çöp kutusunun **solunda** durur ("sil ikonunun yanına" — kullanıcı isteği 2026-10-07); çöp kutusu
 * olmayan satırda tek başınadır. İkisi de yoksa hiçbir şey çizilmez.
 *
 * Bileşen {@code ActionsListPanel}'den bilinçle ayrıldı: panelin bilişsel karmaşıklığı Sonar eşiğinde
 * (S3776, 15) ve satır başına iki koşul daha onu aşırırdı.
 */
export default function ActionListRowActions({ row, onDelete, followEnabled }: Readonly<Props>) {
  const { t } = useTranslation()
  const showFollow = followEnabled && !row.subAction
  const showDelete = onDelete != null && row.deletable
  if (!showFollow && !showDelete) return null
  // Çöp kutusunun erişilebilir adı satırın ADINI taşır (bkz. `deleteLabel`): yirmi satırlık listede sabit
  // "Görevi Sil" adı, sesli kontrol kullanıcısına hangi satırı kastettiğini söylemezdi.
  const removeLabel = deleteLabel(t, deleteLabelKey(row), row.name)
  return (
    <span className="act-row-actions">
      {showFollow && (
        <ActionFollowButton actionId={row.id} name={row.name} followed={row.followed ?? false} />
      )}
      {showDelete && (
        <button
          type="button"
          className="minutes-remove-btn"
          aria-label={removeLabel}
          title={removeLabel}
          onClick={(ev) => {
            // Satır tıklaması Görev Detay'a gider → aksi hâlde onay yerine detay açılırdı.
            ev.preventDefault()
            ev.stopPropagation()
            onDelete?.(row)
          }}
        >
          <i className="pi pi-trash" aria-hidden="true" />
        </button>
      )}
    </span>
  )
}
